export default __webpack_public_path__ + "static/media/alejandro-loguercio-teaching-1.65e1f132.jpg";